import ReactDOM from "react-dom";

export default function FlightDetailsModal({

    flight,

    onClose

}) {

    if (!flight) return null;

return ReactDOM.createPortal(
    

        <div
            style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,.65)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 999999999
            }}
        >

            <div
style={{
    width: "750px",
    maxWidth: "90vw",
    maxHeight: "90vh",



    overflowY: "auto",
    background: "#303640",
    borderRadius: "14px",
    border: "1px solid #5c6672",
    padding: "28px",
    color: "white",
    boxShadow: "0 0 30px rgba(0,0,0,.5)"
}}
            >

                <h2
                    style={{
                        marginTop: 0,
                        marginBottom: "20px"
                    }}
                >
                    ✈ Flight Details
                </h2>

                <div
                    style={{
                        fontSize: "1.35em",
                        fontWeight: 600,
                        marginBottom: "18px"
                    }}
                >
                    {flight.origin} → {flight.destination}
                </div>

                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "18px",
                        marginBottom: "28px"
                    }}
                >

                    <div>
                        <div
                            style={{
                                color: "#8fa1b3",
                                fontSize: ".85em"
                            }}
                        >
                            STATUS
                        </div>

                        <div
                            style={{
                                fontWeight: 600,
                                color:
                                    flight.status === "ACTIVE"
                                        ? "#4caf50"
                                        : "#90caf9"
                            }}
                        >
                            {flight.status}
                        </div>
                    </div>

                    <div>
                        <div
                            style={{
                                color: "#8fa1b3",
                                fontSize: ".85em"
                            }}
                        >
                            AIRCRAFT
                        </div>

                        <div>
                            {flight.aircraft_type || "--"}
                        </div>
                    </div>

                    <div>
                        <div
                            style={{
                                color: "#8fa1b3",
                                fontSize: ".85em"
                            }}
                        >
                            ALTITUDE
                        </div>

                        <div>
                            {flight.altitude || "--"}
                        </div>
                    </div>

                    <div>
                        <div
                            style={{
                                color: "#8fa1b3",
                                fontSize: ".85em"
                            }}
                        >
                            CALLSIGN
                        </div>

                        <div>
                            {flight.callsign || "--"}
                        </div>
                    </div>

                </div>

                <hr
                    style={{
                        borderColor: "#4d5661",
                        margin: "22px 0"
                    }}
                />

                <div
                    style={{
                        color: "#8fa1b3",
                        marginBottom: "8px",
                        fontWeight: 600
                    }}
                >
                    FILED ROUTE
                </div>

                <div
                    style={{
                        background: "#252b33",
                        padding: "14px",
                        borderRadius: "8px",
                        lineHeight: "1.6",
                        wordBreak: "break-word"
                    }}
                >
                    {flight.filed_route || "--"}
                </div>

                <hr
                    style={{
                        borderColor: "#4d5661",
                        margin: "22px 0"
                    }}
                />

                <div
                    style={{
                        color: "#8fa1b3",
                        marginBottom: "8px",
                        fontWeight: 600
                    }}
                >
                    EXPANDED ROUTE
                </div>

                <div
                    style={{
                        background: "#252b33",
                        padding: "14px",
                        borderRadius: "8px",
                        lineHeight: "1.6",
                        wordBreak: "break-word",
                        color: "#8fd3ff"
                    }}
                >
                    {flight.resolved_route || "--"}
                </div>

                <hr
                    style={{
                        borderColor: "#4d5661",
                        margin: "22px 0"
                    }}
                />

                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "18px"
                    }}
                >

                    <div>
                        <div
                            style={{
                                color: "#8fa1b3",
                                fontSize: ".85em"
                            }}
                        >
                            CREATED
                        </div>

                        <div>
                            {flight.created_at
                                ? new Date(flight.created_at).toLocaleString()
                                : "--"}
                        </div>
                    </div>

                    <div>
                        <div
                            style={{
                                color: "#8fa1b3",
                                fontSize: ".85em"
                            }}
                        >
                            STARTED
                        </div>

                        <div>
                            {flight.started_at
                                ? new Date(flight.started_at).toLocaleString()
                                : "--"}
                        </div>
                    </div>

                    <div>
                        <div
                            style={{
                                color: "#8fa1b3",
                                fontSize: ".85em"
                            }}
                        >
                            ENDED
                        </div>

                        <div>
                            {flight.ended_at
                                ? new Date(flight.ended_at).toLocaleString()
                                : "--"}
                        </div>
                    </div>

                </div>

                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "12px",
                        marginTop: "35px"
                    }}
                >

                    {flight.status === "ACTIVE" && (

                        <button
                            style={{
                                padding: "10px 22px",
                                cursor: "pointer"
                            }}
                        >
                            Continue Flight
                        </button>

                    )}

                    <button
                        onClick={onClose}
                        style={{
                            padding: "10px 22px",
                            cursor: "pointer"
                        }}
                    >
                        Close
                    </button>

                </div>

            </div>

        </div>,

        document.getElementById("modal-root")

    );

}